import { Button, CircularProgress } from '@material-ui/core'
import * as React from 'react'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'
import Form from './form'

export interface INativeProps {
  doLogin: () => void
  onForgot: () => void
  loading: boolean
}

interface IProps extends INativeProps, RouteComponentProps {}
interface IState {}

class Content extends React.PureComponent<IProps, IState> {
  state: IState = {}

  render() {
    const { doLogin, onForgot, loading } = this.props
    return (
      <div className="login-container">
        <div className="login-page-content design-fixes">
          <div className="login-page-title">Parent Interface</div>
          <div className="form-container">
            <Form />
          </div>
          <div className="below-login-form">
            <div className="forgot-password-container">
              <a className="link forgot-password" onClick={onForgot}>
                Forgot password?
              </a>
            </div>
          </div>

          <Button
            className="login-button"
            id="1-signin-a"
            onClick={() => doLogin()}
          >
            {loading ? <CircularProgress size={45} /> : 'Sign In'}
          </Button>

          <div className="link-to-sign-up">
            <div className="text">New here? </div>
            <Link to="/signup/parent" className="link">
              Create account
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

const WithRouter = withRouter(Content)

export default (props: INativeProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/pages/Login/content.tsx